import { ResetPass } from 'components/Auth/ResetPass/ResetPass'

export function ResetPassPage(): JSX.Element {
  return <ResetPass />
}
